import { LabDetailsFormData } from 'models/forms';

export const emptyLabDetailsForm = () => {
    return {
        name: '',
        publishLab: false,
        address: {
            street: '',
            postalCode: '',
            city: '',
            country: '',
            deliveryInstructions: '',
        },
        phone: '',
        email: '',
        site: '',
    } as LabDetailsFormData;
};
